module.exports = __webpack_public_path__ + "static/media/ic-slider-arrow.81540a76.svg";